import { useQuery } from "@apollo/client";
import { PENDING_GOOGLE_CONNECTION_QUERY } from "@/graphql/google-business";
import { useSalonStore } from "@/lib/store/salon";

export function useGoogleBusinessPending(enabled: boolean) {
  const { currentSalon } = useSalonStore();
  const salonId = currentSalon?.id;

  const { data, loading, error, refetch } = useQuery(PENDING_GOOGLE_CONNECTION_QUERY, {
    variables: { salonId: salonId ?? "" },
    skip: !enabled || !salonId,
    fetchPolicy: "network-only",
    errorPolicy: "all",
  });

  return {
    locations: data?.pendingGoogleConnection?.locations ?? null,
    loading,
    error,
    refetch,
  };
}
